module.exports = __webpack_public_path__ + "static/img/2.71f39a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/2.png
// module id = Mrc6
// module chunks = 35